import React from 'react'
import { Modal } from 'react-bootstrap'

export default class modalDelete extends React.Component {
    render() {
        const { ShowModalDelete, CancelHandler, DeleteHandler2, Model, Mode } = this.props

        return (
            <div>
                <Modal show={ShowModalDelete} onHide={CancelHandler}>
                    <Modal.Header closeButton>
                        <Modal.Title>Success Delete Faskes</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <p>Success Delete Faskes</p>

                    </Modal.Body>

                    
                </Modal>

            </div>
        )
    }
}